export default __webpack_public_path__ + "static/oleo-camera-b386eebe029fa2e87b366a3aa72131f0.jpg";